"use client";
import { Link } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import React from "react";

type NavLinkProps = {
  href: string;
  children: React.ReactNode;
  variant: "navbar" | "footer";
  isActive: boolean;
  onClick?: () => void;
  className?: string;
  noPrefetch?: boolean;
};

const NavLink: React.FC<NavLinkProps> = ({
  href,
  children,
  variant,
  isActive,
  onClick,
  className = "",
  noPrefetch = false,
}) => {
  const t = useTranslations();

  const LinkStyle = {
    navbar: `font-inter text-sm 2xl:text-base text-black xl:py-2 py-3  2xl:px-4  xl:px-2 2xl:px-3 xl:mx-1 2xl:mx-2  hover:bg-[#345A8C1A] rounded-full no-underline  hover:text-black transition-all duration-300
    ${isActive ? "bg-primary-light text-primary rounded-[10rem] font-semibold" : ""} ${className}`,
    footer: `font-inter text-sm font-normal text-white hover:underline ${className}`,
  };

  // Translate if children is a translation key, otherwise use as-is
  const content = typeof children === "string" && children.includes(".") ? t(children as any) : children;

  return (
    // Default (auto) prefetch: `true` forced a full prefetch of every dynamic route, including its JS.
    <Link href={href} className={LinkStyle[variant]} prefetch={noPrefetch ? false : undefined} onClick={onClick}>
      {content}
    </Link>
  );
};

export default NavLink;
